<template>
	<div>
		<div class="gPageBorder">
			<el-row style="margin-bottom:24px">

				<el-col :span="8" style="">
					<!-- <el-button v-show='isCreate' class='gSgLeftBtn'  type="primary" @click="add"  >{{$t('lin_global.cjzs')}}</el-button> -->
					<el-button class='gSgLeftBtn' type="primary" @click="open_add">
						{{$t('app_new')}}
					</el-button>
					<el-button class='gSgLeftBtn' type="primary" @click="open_import">
						{{$t('app_Batch_import')}}
					</el-button>
					<el-button class='gSgLeftBtn' type="primary" @click="push_device">
						{{$t('app_Batch_push')}}
					</el-button>
					<el-button type="danger" :disabled="id_list.length > 0 ? false : true" @click="batchDelete">{{$t('advert.deleteAll')}}</el-button>
				</el-col>


			</el-row>


			<el-row style="margin-bottom:24px">


				<el-col :span="4">
					<div class='gSideCtrl'>
						<el-input :placeholder="$t('app_input_sn')"  v-model="select_form.terminalNo"> </el-input>
					</div>
				</el-col>

				<el-col :span="4">
					<div class='gCtrl'>
						<MechanismSelector style='' :data="mechanismData"></MechanismSelector>
					</div>
				</el-col>

				<el-col :span="4">
					<div class='gCtrl'>
						<el-select v-model="select_form.status" clearable :placeholder="$t('app_status')" >
							<el-option v-for="item in ctyps" :key="item.vl" :label="item.lb" :value="item.vl">
							</el-option>
						</el-select>
					</div>
				</el-col>



				<el-col :span="4">
					<div class='gSideCtrl' style="text-align: center;">
						<el-button type='primary' @click='getData'>{{$t('app_query')}}</el-button>
					</div>
					<!-- <div class='gSideCtrl' style="text-align: center;">
						<el-button type='primary' @click='getData'>{{$t('app_query')}}</el-button>
					</div> -->
				</el-col>

			</el-row>






			<el-table class='' v-loading="loading" :data="tableData2" id="tp" @selection-change="handleSelectionChange_1" border style="margin-bottom: 20px;">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="terminalNo" align="center" header-align="center" :label="$t('app_serialnumber')">

				</el-table-column>
				<el-table-column prop="terminalNoNew" align="center" header-align="center" :label="$t('app_serialnumber_new')">
				
				</el-table-column>
				<el-table-column prop="terminalName" align="center" header-align="center" :label="$t('app_deviceName')">

				</el-table-column>
				<el-table-column prop="mechName" align="center" header-align="center"
					:label="$t('lin_global.label_areaid')">

				</el-table-column>
				<el-table-column align="center" header-align="center" prop="status" :label="$t('app_status')" width="">
					<template slot-scope="scope">
						<el-tag type="info" v-if="scope.row.status == 0">{{$t('app_status_update')}}
						</el-tag>
						<el-tag type="success" v-if="scope.row.status == 1">{{$t('app_status_updated')}}
						</el-tag>
						<el-tag type="warning" v-if="scope.row.status == 2">{{$t('app_status_exist')}}
						</el-tag>
						<el-tag type="danger" v-if="scope.row.status == 3">{{$t('app_status_fail')}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column align="center" header-align="center" prop="snStatus" :label="$t('app_termin_status')" width="">
					<template slot-scope="scope">
						<el-tag :hit="true" v-if="scope.row.snStatus == 0">{{$t('app_status_update')}}
						</el-tag>
						<el-tag type="success" :hit="true" v-if="scope.row.snStatus == 1">{{$t('app_success')}}
						</el-tag>
						<el-tag type="danger" :hit="true" v-if="scope.row.snStatus == 2">{{$t('app_status_fail')}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" align="center" header-align="center"
					:label="$t('lin_global.createTime')">
				</el-table-column>

				<el-table-column header-align="center" align="center" :label="$t('lin_global.ope')" width="110">
					<template slot-scope="scope">


						<el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
							<el-button type='text' @click="deleteRow(scope.row.id)"><i class="fa fa-trash"
									style="color:#FF4949"></i></el-button>
						</el-tooltip>

					</template>
				</el-table-column>
			</el-table>
			<div class="gPgDiv">
				<el-pagination style='' class='gPg' @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,50,100]"
					:page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">
				</el-pagination>
			</div>
		</div>



		<el-dialog class='gDia' :title="$t('app_adddv')" v-model="pushdev" @close='handleClose' size=''>
			<div v-loading='loading' id='' class='gBorder'>
				<el-row style=''>
					<el-col :span="4">

						<el-button type='primary' :disabled="push_list.length == 0" @click='bcPush' class='gSgLeftBtn'
							style=''>{{$t('app_pushsldev')}}</el-button>
						<!-- <el-button type='primary' class='' @click='pushAll' style=''>{{$t('app_pushAll')}}</el-button>
						<el-button type='primary' class='' @click='fileImport' style=''>{{$t('app_fileImport')}}
						</el-button> -->

					</el-col>
					<el-col v-show='true' :offset="0" :span="4">
						<div class='gCtrl'>
							<el-select @change='get_device_list' clearable v-model="form.cmtStatus"
								:placeholder="$t('app_status')">
								<el-option v-for="item in cmtStatusArr" :key="item.vl" :label="item.lb"
									:value="item.vl">
								</el-option>
							</el-select>
						</div>
					</el-col>
					<el-col v-show='true' :offset="0" :span="4">
						<div class='gCtrl'>
							<el-select @change='get_device_list' clearable v-model="form.secretKeyDownload"
								:placeholder="$t('app_dyf')">
								<el-option v-for="item in secretKeyDownload_list" :key="item.vl" :label="item.lb"
									:value="item.vl">
								</el-option>
							</el-select>
						</div>
					</el-col>	

					<el-col v-show='true' :offset="0" :span="4">
						<div class='gCtrl'>
							<el-select @change='get_device_list' clearable v-model="form.secretKeyExist"
								:placeholder="$t('app_wtk')">
								<el-option v-for="item in secretKeyExist_list" :key="item.vl" :label="item.lb"
									:value="item.vl">
								</el-option>
							</el-select>
						</div>
					</el-col>

					<el-col v-show='true' :offset="0" :span="4">
						<div class='gCtrl'>
							<MechanismSelector style='width:100%;' :data="mechanismData_2"></MechanismSelector>
						</div>
					</el-col>
					<el-col v-show='true' :span="4">
						<div class='gSideCtrl'>
							<el-input :placeholder="$t('app_terNo')" icon='search' :on-icon-click='get_device_list'
								@keyup.enter.native='get_device_list' v-model='form.terminalNo'></el-input>
						</div>
					</el-col>
				</el-row>

				<el-table class='gTopMg' ref="multipleTable" id='dpTable' :data="tableData" border tooltip-effect="dark"
					style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column type="selection" align='center' width="55">
					</el-table-column>
					<el-table-column prop="terminalNo" align='center' :label="$t('app_terNo')" width="210">
					</el-table-column>
					<el-table-column align='center' prop="terminalName" :label="$t('app_terName')" width="210">
					</el-table-column>
					<el-table-column prop="terminalStatus" align='center' :label="$t('app_status')" width="210">
						<template slot-scope="scope">
							<span>
								<tagc :tagobj="{type: 'terSt', vl: scope.row.terminalStatus}"></tagc>
							</span>
						</template>
					</el-table-column>
					<el-table-column align='center' prop="mechName" :label="$t('app_distributor')" width="210">
					</el-table-column>

					<el-table-column prop="operate" :label="$t('app_operate')" align='center' width='106'>
						<template slot-scope='scope'>


							<el-tooltip class="item" effect="dark" :content="$t('lin_btn.send')" placement="top">
								<el-button @click='pushed(scope.row)' type=text><i class="fa fa-upload" style=""></i>
								</el-button>
							</el-tooltip>

						</template>
					</el-table-column>
				</el-table>

				<div class="gPgDiv">

					<el-pagination class='gPg' @current-change="pageSelect" @size-change="pageSized"
						:current-page="page" :page-sizes='[20,100]' :page-size="ttpage"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</el-dialog>

		<el-dialog class='gDia' :title="$t('app_fipush') " v-model="pushImport" @close='closeImport'>
			<el-form model="" rules="" ref="">
				<el-form-item :label="$t('app_ulfile')" :label-width="formLabelWidth">

					<el-upload class="upload-demo" ref="upload" name="fileUpload" :action="ulurl()"
						:before-upload="srcBefore" :on-success="srcSuccess" :on-error='ulError' :file-list="fileList"
						:auto-upload="false">
						<el-button slot="trigger" size="small" type="primary">{{$t('app_clickUpdate')}}</el-button>
						<a :href="downTpl" style="margin-left:8px;margin-right:10px;">
							<el-button type="success" size='small'>{{$t('terminal.list.import_muban')}}</el-button>
						</a>
					</el-upload>

				</el-form-item>
				<el-form-item :label="$t('app_deviceNum')" :label-width="formLabelWidth">
					{{uldata?uldata.terNums : 0 + $t('app_amechine')}}
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<!-- <span style="margin-right:10px;" v-show="info.type === '1'">
		    <el-checkbox v-model="check1">{{$t('app_autoscopen')}}</el-checkbox>
		    <el-checkbox v-model="check2">{{$t('app_psscandtip')}}</el-checkbox>
		  </span>
		  <span style="margin-right:10px;" v-show="info.type === '2'">
		    <el-checkbox v-model="check1">{{$t('app_tipud')}}</el-checkbox>
		    <el-checkbox v-model="check2">{{$t('app_tipdown')}}</el-checkbox>
		  </span> -->
				<el-button @click="pushImport = false">{{$t('app_cancel')}}</el-button>
				<el-button  style="margin-left: 10px;" type="primary" @click="submitUpload">
					{{$t('app_srpush')}}
				</el-button>
			</span>
		</el-dialog> 

	</div>
</template>

<script>
	import axios from 'axios'
	import {
		baseurl,
		focusEvent,
		urlAssets
	} from '../../api/url'
	import city from '../city.js'
	// import sFile from 'save-file'
	import AutoTerno from '../global/TernoAutoCtrl'
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	import tagc from '@/components/global/tagc'
	export default {
		components: {
			AutoTerno,
			MechanismSelector,
			tagc
		},
		data() {
			var that = this
			return {
				pushdev: false,
				push_list: [],
				id_list:[],
				ttpage: 20,
				tableData: [],
				total: 0,
				page: 1,
				cmtStatusArr: [{
						vl: "1",
						lb: this.$t('app_online'),
					},
					{
						vl: "2",
						lb: this.$t('app_offline'),
					}, {
						vl: "0",
						lb: this.$t('app_new'),
					},
					{
						vl: "3",
						lb: this.$t('app_sleep'),
					}
				],
				secretKeyDownload_list:[{
						vl: "0",
						lb: this.$t('app_no'),
					},
					{
						vl: "1",
						lb: this.$t('app_yes'),
					}
				],
				secretKeyExist_list:[{
						vl: "0",
						lb: this.$t('app_no'),
					},
					{
						vl: "1",
						lb: this.$t('app_yes'),
					}
				],
				isNon: false,
				pushImport: false,
				fileList: [],
				uldata: '',
				snum: 0,
				downTpl: `${urlAssets.prefix}tms-server-web/model/kmc_terminalNos.xlsx`,
				importTemplate: `${urlAssets.prefix}tms-server-web/import/terminalList.do`,
				formLabelWidth: '28.5%',

				mechanismData: {
					callback(value) {
						that.select_form.mechId = value
						// that.query()
					}
				},
				mechanismData_2: {
					callback(value) {
						that.form.mechId = value
						that.get_device_list()
					}
				},
				mech: '',
				ctyps: [{
						vl: '0',
						lb: this.$t('app_status_update')
					},
					{
						vl: '1',
						lb: this.$t('app_status_updated')
					},
					{
						vl: '2',
						lb: this.$t('app_status_exist')
					},
					{
						vl: '3',
						lb: this.$t('app_status_fail')
					}
				],
				ctype: '',
				queryKey: '',
				ahref: '',
				form: {
					terminalNo: '',
					cmtStatus: "",
					mechId: '',
					secretKeyDownload:"",
					secretKeyExist:""
					
				},
				select_form: {
					terminalNo: "",
					status: "",
					mechId: ""
				},
				rules: {
					'terminalNo': [{
						required: true,
						message: this.$t('lin_global.quorter')
					}]
				},
				type: [{
					typename: this.$t('lin_global.label_areaid'),
					typeid: '2'
				}, {
					typename: this.$t('lin_global.shebei'),
					typeid: '1'
				}],
				sel: [],
				sel2: [],
				options: city,
				focusEvent: focusEvent,
				riskId: '',
				radius: '',
				citys: '',
				radius2: '',
				citys2: '',
				input1: '',
				value1: '',
				areaList1: [],
				dialogFormVisible: false,
				dialogFormVisible2: false,
				dialogTopMgVisible: false,
				currentPage: 1,
				pageSize: 10,
				totalRecords: 0,
				currentPage1: 1,
				areaList: [],
				arrdata1: [],
				tableData2: [],
				xiafaVisible: false,
				zhengshu: '',
				qudaoshangxinxi: '',
				qudaoshangid: '',
				zhengshutype: '',
				isShow: true,
				isSubmit: false,
				loading: true,

			}
		},
		created() {
			this.getData();
		},
		computed: {
			isCreate() {
				return localStorage.userType === '0'
			},
			isCerUpload() {
				// return localStorage.cerType === '0'
				return true
			}
		},
		methods: {
			ulurl () {
			 var url = this.$push_device_Url + '?token=' + localStorage.user + '&language=' + localStorage.system_lang
			//  alert(url)
			 return url
			},
			// 上传
			submitUpload() {
				this.$refs.upload.submit()
				// this.loading = true
				// this.$appendPush(this.pObj.taskId, '', '2', '', '', this.uldata.fileNo, '', (res) => {
				// 	this.loading = false
				// 	if (res.status === 200) {
				// 		//console.log(res.data)
				// 		this.$message.success(res.message)
				// 		this.pushdev = false
				// 	} else {
				// 		this.$message.error(res.message)
				// 	}
				// }, () => {
				// 	this.loading = false
				// })
				// this.pushImport = false
			},
			//  打开文件导入窗口
			open_import() {
				this.pushImport = true;
			},
			// 关闭文件导入窗口
			closeImport() {
				this.pushImport = false;
				this.fileList = []
				this.uldata = ''
			},
			// 批量导出
			push_device(){
				this.$outputDevice(this.select_form.terminalNo,this.select_form.status,this.select_form.mechId)
			},
			// 批量删除
			batchDelete () {
				let temp_list = []
				for (var i = 0; i < this.id_list.length; i++) {
					temp_list.push(this.id_list[i].id)
				}
				this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					axios.post(`${baseurl}/kmc/delete.do`, {
						id: String(temp_list)
					}).then(res => {
						//console.log("打印看看删除返回信息")
						//console.log(res.data);
						if (res.data.status == 200) {
							this.$message.success(this.$t('lin_global.delete_success'));
							this.getData();
						} else {
							this.$message.error(res.data.message)
						}
					})
				}).catch(() => {
				
				})
				
			},
			// 上传前
			srcBefore(file) {
				window[this.$route.path] = 1
			},
			// 上传成功
			srcSuccess(res, file) {
				window[this.$route.path] = ''
				//console.log(res, this.fileList)

				if (res.status === 200) {
					// this.fileList = [{
					// 	name: file.name
					// }]
					// this.uldata = res.data
					this.$message.success(res.message)
					this.closeImport()
				} else {

					// this.srcList = []

					this.$message.error(res.message)
				}
			},
			// 上传失败
			ulError() {
				window[this.$route.path] = ''
			},

			// 打开添加设备窗口
			open_add() {
				this.pushdev = true
				this.get_device_list()
			},
			pageSized(vl) {
				this.ttpage = vl
				this.get_device_list()
			},
			pageSelect(vl) {
				this.page = vl
				this.get_device_list()
			},
			// 批量导入
			fileImport() {
				// this.pushImport = true
			},
			// 推送选中设备
			pushed(row) {
				this.$showConfirm(this.$t('app_tip'), this.$t('app_srpush') + ' ?', this.$t('app_sure'), this.$t(
					'app_cancel'), 'warning', () => {
					this.$device_push({
						terminalNo: row.terminalNo
					}, (res) => {
						this.loading = false
						if (res.status === 200) {
							//console.log(res.data)
							this.$message.success(res.message)
							this.handleClose();
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						// error
						this.loading = false
					})
				}, '')
			},
			// 批量推送
			bcPush() {
				let terminal_list = []
				for (var i = 0; i < this.push_list.length; i++) {
					terminal_list.push(this.push_list[i].terminalNo)
				}
				this.$device_push({
					terminalNo: String(terminal_list)
				}, (res) => {
					this.loading = false
					if (res.status === 200) {
						//console.log(res.data)
						this.$message.success(res.message)
						this.handleClose();
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
					this.loading = false
				})
			},
			// 推送全部
			pushAll() {
				this.$showConfirm(this.$t('app_tip'), this.$t('app_ispushalldv') + ' ?', this.$t('app_sure'), this.$t(
					'app_cancel'), 'warning', () => {
					// this.$appendPush(this.pObj.taskId, '', '1', this.mech, this.queryKey, '', terminalstats, (
					// 	res) => {
					// 	this.loading = false
					// 	if (res.status === 200) {
					// 		//console.log(res.data)
					// 		this.$message.success(res.message)
					// 		this.pushdev = false
					// 	} else {
					// 		this.$message.error(res.message)
					// 	}
					// }, () => {
					// 	// error
					// 	this.loading = false
					// })
				}, '')
			},
			// 获取设备列表
			get_device_list() {
				this.loading = true
				var mc = this.form.mechId
				var tno = this.form.terminalNo
				var tstatus = this.form.cmtStatus
				
				
				
				this.$get_device_list(this.page, this.ttpage,this.form.secretKeyDownload,this.form.secretKeyExist, mc, tno, tstatus, '', '', '', (res) => {
					this.loading = 0
					if (res.status === 200) {
						//console.log(res.data)
						this.tableData = res.data
						this.total = res.total
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
					this.loading = 0
				})
			},
			handleSelectionChange_1(vl) {
				this.id_list = vl
			},
			handleSelectionChange(vl) {
				this.push_list = vl
			},
			
			
			handleClose() {
				this.pushdev = false
				this.form = {
					terminalNo: '',
					cmtStatus: "",
					mechId: '',
					secretKeyDownload:"",
					secretKeyExist:""
				}
				var that = this;
				this.mechanismData_2 = {
					callback(value) {
						that.form.mechId = value
						that.get_device_list()
					}
				}
				this.getData()
			},
			query() {
				this.getData()
			},
			deleteRow(id) {
				this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					axios.post(`${baseurl}/kmc/delete.do`, {
						id: id
					}).then(res => {
						//console.log("打印看看删除返回信息")
						//console.log(res.data);
						if (res.data.status == 200) {
							this.$message.success(this.$t('lin_global.delete_success'));
							this.getData();
						} else {
							this.$message.error(res.data.message)
						}
					})
				}).catch(() => {

				})
			},

			handleSizeChange: function(val) {
				this.pageSize = val
				this.getData()
			},

			handleCurrentChange: function(val) {
				this.currentPage = val
				this.getData()
			},

			getData() {
				// this.currentPage = page;
				var data = {
					page: this.currentPage,
					rows: this.pageSize,
					terminalNo: this.select_form.terminalNo,
					status: this.select_form.status,
					mechId: this.select_form.mechId
				};
				axios.post(`${baseurl}/kmc/pageList.do`, data).then(res => {
					//console.log("打印返回列表2");
					//console.log(res.data);
					if (res.data.status == 200) {
						this.tableData2 = res.data.data;
						this.totalRecords = res.data.total;
						this.loading = false;
					} else {
						this.loading = false;
					}

				})
			}
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// number_21.vue?69b0fb40